function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import Loading from "../../../helperComponents/Loading/Loading";
import { getVersionsQueryKey } from "../actions/PolizaRenewalActions";
import { getFormattedDate } from "../../../utils/datetime";
var CHANGE_LABELS = {
  inspection_needed: "Inspección requerida",
  condition_update_reason: "Razón del cambio de condiciones",
  condition: "Condición de renovación",
  condition_details: "Detalles de la condición",
  comments: "Comentarios del cambio",
  affects_net_bonus: "Prima neta afecta",
  exempt_net_bonus: "Prima neta exenta",
  net_bonus: "Prima neta",
  client_rejects_renewal_reason: "Razón de rechazo (Cliente)",
  company_rejects_renewal_reason: "Razón de rechazo (Compañía)",
  extension_days: "Días de prórroga",
  aasm_state: "Estado"
};
var STATUS_TRANSLATIONS = {
  pending: "Pendiente de condiciones",
  in_progress: "Consultando cliente/compañía",
  with_conditions: "Condición cargada",
  renewed: "Renovada",
  not_renewed: "No renovada"
};

var humanizeChangeLabel = function humanizeChangeLabel(key) {
  if (CHANGE_LABELS[key]) return CHANGE_LABELS[key];
  return key.replace(/_/g, " ");
};

var translateStatusValue = function translateStatusValue(value) {
  if (STATUS_TRANSLATIONS[value]) return STATUS_TRANSLATIONS[value];
  return value;
};

var PolizaRenewalVersionListItem = function PolizaRenewalVersionListItem(props) {
  var polizaRenewalVersion = props.polizaRenewalVersion,
      admin = props.admin;
  var queryClient = useQueryClient();

  var _React$useState = React.useState(polizaRenewalVersion),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      version = _React$useState2[0],
      setVersion = _React$useState2[1];

  var indexQueryKey = getVersionsQueryKey(polizaRenewalVersion.item_id);

  var refreshList = function refreshList() {
    queryClient.invalidateQueries({
      queryKey: getVersionsQueryKey(polizaRenewalVersion.item_id)
    });
  };

  var canReject = admin && (admin.is_super_admin || admin.permissions_code.includes("poliza_renewal_version_approve_reject"));
  var isAbleToEdit = false;

  var _useMutation = useMutation({
    mutationFn: function mutationFn() {
      return (// NOT SURE IF WE WANNA USE VERSIONS TO HANDLE THE REJECT ACTION
        axios.post("/api/v1/versions/".concat(version.id, "/reject"))
      );
    },
    onSuccess: function onSuccess(response) {
      refreshList();
      setVersion(response.data);
    }
  }),
      isLoadingReject = _useMutation.isLoading,
      errorReject = _useMutation.error,
      rejectVersion = _useMutation.mutate,
      rejectedVersion = _useMutation.data;

  var submitReject = function submitReject() {
    rejectVersion();
  };

  var renderRejectButton = function renderRejectButton() {
    if (isLoadingReject) return /*#__PURE__*/React.createElement("button", {
      className: "btn btn-disabled"
    }, /*#__PURE__*/React.createElement(Loading, null));
    if (errorReject) return "error!";

    if (version.permitted_events.find(function (e) {
      return e === "reject";
    }) && isAbleToEdit) {
      return /*#__PURE__*/React.createElement("button", {
        className: "btn btn-danger",
        onClick: submitReject,
        style: {
          width: "100px"
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "glyphicon glyphicon-remove"
      }), "Rechazar");
    } else {
      return;
    }
  };

  if (!version) return null;

  var renderObjectChanges = function renderObjectChanges() {
    if (!version.object_changes) {
      return /*#__PURE__*/React.createElement("p", {
        className: "text-muted mb-0"
      }, "Sin diferencias registradas.");
    }

    var filteredChanges = Object.entries(version.object_changes).filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          key = _ref2[0];

      return key !== "company_conditions_document" && key !== "updated_at" && key !== "created_at";
    });

    if (filteredChanges.length === 0) {
      return /*#__PURE__*/React.createElement("p", {
        className: "text-muted mb-0"
      }, "Sin diferencias registradas.");
    }

    return /*#__PURE__*/React.createElement("dl", {
      className: "dl-horizontal renewalChanges"
    }, filteredChanges.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];

      var isAasmState = key === "aasm_state";
      var displayValue0 = isAasmState && value[0] ? translateStatusValue(value[0]) : value[0];
      var displayValue1 = isAasmState && value[1] ? translateStatusValue(value[1]) : value[1];
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: key
      }, /*#__PURE__*/React.createElement("dt", null, humanizeChangeLabel(key), ":"), /*#__PURE__*/React.createElement("dd", null, displayValue0 ? displayValue0 : "", displayValue0 && displayValue1 ? " → " : "", displayValue1 ? displayValue1 : ""));
    }));
  };

  var renderCommentsBlock = function renderCommentsBlock() {
    if (version.comments && version.comments.length > 0) {
      return /*#__PURE__*/React.createElement("p", {
        className: "mb-0"
      }, version.comments);
    }

    return /*#__PURE__*/React.createElement("p", {
      className: "text-muted mb-0"
    }, "Sin comentarios.");
  };

  var renderInformation = function renderInformation() {
    return /*#__PURE__*/React.createElement("small", {
      title: getFormattedDate(version.created_at)
    }, "Realizado por ", version.whodunnit || "Desconocido", " el ", getFormattedDate(version.created_at), " hrs.");
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "row no-gutters renewalHistoryItem"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-lg-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "renewalVersionMeta",
    title: getFormattedDate(version.created_at)
  }, /*#__PURE__*/React.createElement("span", {
    className: "renewalVersionButton"
  }, version.item_id), /*#__PURE__*/React.createElement("span", {
    className: "badge renewalVersionBadge"
  }, "Versi\xF3n: ", version.id))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-lg-5"
  }, renderObjectChanges()), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-lg-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "renewalComments"
  }, /*#__PURE__*/React.createElement("span", {
    className: "renewalCommentsLabel"
  }, "Comentarios:"), renderCommentsBlock())), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-lg-2 text-lg-right"
  }, renderInformation()));
};

export default PolizaRenewalVersionListItem;